import React from 'react';
import { usePersistentValueLocal } from '../hooks/usePersistentState';
import { useTranslation } from 'react-i18next';
import PageShell from '../components/PageShell';
import Tabs from '../components/Tabs';
import { resolveTabs } from '../i18n/resolveTabs';
import TenantSettingsPage from './TenantSettingsPage';
import CashActualsPage from './CashActualsPage';
import ClosingPeriodCard from './financials/ClosingPeriodCard';

/* Finance › Paramètres — réglages financiers du client, rapatriés du hub
   Paramètres le 2026-08-10 : ils portent sur l'argent, ils vivent donc dans le
   module Finance (la Structure, elle, décrit le plan de reporting).
     • Clôture → dernier mois réel clôturé (frontière réel / prévision)
     • TVA     → taux par année
     • Finance → lignes de crédit (découvert autorisé)
   Gabarit unique : <PageShell framed> + <Tabs> + sous-pages en mode embedded. */
const TAB_DEFS = [
  // La clôture d'abord : c'est le réglage qu'on touche le plus souvent (chaque
  // mois), et celui qui déplace la frontière réel/prévision partout.
  { id: 'closing', labelKey: 'finance:settings.tabs.closing' },
  { id: 'vat', labelKey: 'finance:settings.tabs.vat' },
  { id: 'credit', labelKey: 'finance:settings.tabs.credit' },
];

export default function FinancialsSettingsHub({ activeTenant, onTenantPatched, addToast, year, embedded = false }) {
  const { t } = useTranslation();
  /* Onglet mémorisé : un lien venu d'un autre écran (ex. « Paramètres › TVA »
     depuis la section TVA) écrit la clé avant de naviguer, et le hub s'ouvre au
     bon endroit (2026-08-17). */
  const [tab, setTab] = usePersistentValueLocal('fin_settings_tab', 'closing');
  const TABS = resolveTabs(TAB_DEFS, t);

  /* `embedded` : rendu SANS gabarit de page (2026-09-27). Dans les Paramètres
     du client, la page porte déjà son titre et le panneau le redit à gauche ;
     un troisième « Paramètres » au-dessus des onglets ne disait rien de plus. */
  const Shell = embedded
    ? ({ children }) => <>{children}</>
    : ({ children }) => <PageShell framed title={t('finance:settings.title')}>{children}</PageShell>;
  return (
    <Shell>
      <Tabs tabs={TABS} active={tab} onChange={setTab} />

      <div className="page-shell__panel">
        {tab === 'closing' && (
          <ClosingPeriodCard
            activeTenant={activeTenant}
            onTenantPatched={onTenantPatched}
            addToast={addToast}
          />
        )}
        {tab === 'vat' && (
          <TenantSettingsPage
            embedded
            sections={['vat']}
            activeTenant={activeTenant}
            onTenantPatched={onTenantPatched}
            addToast={addToast}
          />
        )}
        {tab === 'credit' && (
          <CashActualsPage
            embedded
            activeTenant={activeTenant}
            addToast={addToast}
            year={year}
          />
        )}
      </div>
    </Shell>
  );
}
